export const navData = [
  {
    title: "About Us",
    icon: "/assets/svg/aboutus.svg",
    link: "/aboutus",
  },

  {
    title: "For Businesses",
    icon: "/assets/svg/business.svg",
    link: "/forbusiness",
  },
  {
    title: "For Individuals",
    icon: "/assets/svg/individuals.svg",
    link: "/for-individuals",
  },
  {
    title: "Resources",
    icon: "/assets/svg/resources.svg",
    link: "/resources",
  },
  {
    title: "Contact Us",
    icon: "/assets/svg/contactus.svg",
    link: "/contactus",
  },
  // {
  //   title: "",
  //   icon: require("../../../Assets/Images/Navbar/search-icon.png"),
  //   link: "/search",
  // },
  // {
  //   title: "",
  //   icon: require("../../../Assets/Images/Navbar/account-icon.png"),
  //   link: "/account",
  // },
  // {
  //   title: "",
  //   icon: require("../../../Assets/Images/Navbar/menu-icon.png"),
  //   link: "/menu",
  // },
];

export const tooltipData = [
  {
    title: "About Us",
    icon: require("../../../Assets/Images/Navbar/about us-icon.png"),
    link: "/aboutus",
  },
  {
    title: "For Business",
    icon: require("../../../Assets/Images/Navbar/For business-icon.png"),
    link: "/forbusiness",
  },
  {
    title: "For Individuals",
    icon: require("../../../Assets/Images/Navbar/For individuals-icon.png"),
    link: "/for-individuals",
  },
  {
    title: "Resources",
    icon: require("../../../Assets/Images/Navbar/resourse-icon.png"),
    link: "/resources",
  },
  {
    title: "Contact Us",
    icon: require("../../../Assets/Images/Navbar/contact us-icon.png"),
    link: "/contactus",
  },
  // {
  //   title: "Search",
  //   icon: require("../../../Assets/Images/Navbar/search-icon.png"),
  //   link: "/search",
  // },
  {
    title: "Account",
    icon: require("../../../Assets/Images/Navbar/account-icon.png"),
    link: "/account",
  },
  // {
  //   title: "Menu",
  //   icon: require("../../../Assets/Images/Navbar/menu-icon.png"),
  //   link: "/menu",
  // },
];
